<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		hexCode?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', hexCode = undefined, title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M21.5824 8.21463C21.5824 8.21463 21.3915 6.86643 20.8033 6.27445C20.0586 5.49532 19.226 5.4915 18.844 5.44567C16.1095 5.24707 12.0038 5.24707 12.0038 5.24707H11.9961C11.9961 5.24707 7.89043 5.24707 5.15584 5.44567C4.77392 5.4915 3.94132 5.49532 3.19657 6.27445C2.6084 6.86643 2.42126 8.21463 2.42126 8.21463C2.42126 8.21463 2.22266 9.79962 2.22266 11.3808V12.8627C2.22266 14.4438 2.41744 16.0288 2.41744 16.0288C2.41744 16.0288 2.6084 17.377 3.19275 17.969C3.9375 18.7481 4.91523 18.7214 5.35062 18.8054C6.91652 18.9544 11.9999 19.0002 11.9999 19.0002C11.9999 19.0002 16.1095 18.9926 18.844 18.7978C19.226 18.7519 20.0586 18.7481 20.8033 17.969C21.3915 17.377 21.5824 16.0288 21.5824 16.0288C21.5824 16.0288 21.7772 14.4476 21.7772 12.8627V11.3808C21.7772 9.79962 21.5824 8.21463 21.5824 8.21463ZM9.97956 14.6615V9.16562L15.2616 11.9231L9.97956 14.6615Z"
		fill={hexCode || getTailwindColor(color)}
	/>
</SvgWrapper>
